export default {"src":"/_next/static/media/carDetailShowInfoIcon.698abf10.svg","height":14,"width":14};